export  const  defaultTexts={
    title:'Nikita',
    description:"Nikita",
}

export const REQUEST_TYPE = {
    success: "success",
    error: "error",
    title: "title",
}